import React from 'react';
import styled from 'styled-components';
import { zPositions } from '@/constants';

import { Checkbox, Switch, Text, Title, Tooltip, Icon } from 'components';
import { useContactState } from './hooks';

const Permissions: React.FC = () => {
  const [contactState, updateContactState] = useContactState();
  const { canConfirmAppts, canDenyAppts, canSuggestTime } = contactState;

  const handleOnCheck = (
    key: 'canConfirmAppts' | 'canDenyAppts' | 'canSuggestTime',
    value: boolean,
  ) => {
    const updatedPermissions = {
      canConfirmAppts,
      canDenyAppts,
      canSuggestTime,
      [key]: value,
    };

    if (key === 'canDenyAppts' && !value) {
      updatedPermissions.canSuggestTime = false;
    }

    updateContactState(updatedPermissions);
  };

  return (
    <StyledContainer>
      <Title level={2} data-cy={'permissions-title'}>
        Permissions
        <Tooltip
          zIndex={zPositions.contactModalComponents}
          title={
            'Enabling a permission will allow this contact ' +
            'to take that action on showings for this listing.'
          }
        >
          <Inline>
            <Icon type="antdInfoCircleFilled" color="black" />
          </Inline>
        </Tooltip>
      </Title>
      <StyledPermissionsContainer>
        <StyledSwitchContainer data-cy={'edit-contact-row-can-confirm'}>
          <Switch
            checkedChildren="On"
            unCheckedChildren="Off"
            checked={canConfirmAppts}
            onChange={value => {
              handleOnCheck('canConfirmAppts', value);
            }}
          />{' '}
          <Text strong>Can Confirm</Text>
        </StyledSwitchContainer>
        <StyledSwitchContainer data-cy={'edit-contact-row-can-deny'}>
          <Switch
            checkedChildren="On"
            unCheckedChildren="Off"
            checked={canDenyAppts}
            onChange={value => {
              handleOnCheck('canDenyAppts', value);
            }}
          />{' '}
          <Text strong>Can Deny/Cancel</Text>
        </StyledSwitchContainer>
        {canDenyAppts && (
          <Checkbox
            checked={canSuggestTime}
            onChange={event => {
              handleOnCheck('canSuggestTime', event.target.checked);
            }}
            data-cy={'edit-contact-toggle-soft-suggest'}
          >
            <Text strong>Allow this contact to soft suggest time</Text>
          </Checkbox>
        )}
      </StyledPermissionsContainer>
    </StyledContainer>
  );
};

export default Permissions;

const StyledContainer = styled.div``;

const StyledPermissionsContainer = styled.div`
  display: grid;
  gap: 12px;
`;

const StyledSwitchContainer = styled.div`
  display: inline-grid;
  grid-template-columns: auto 1fr;
  width: auto;
`;

const Inline = styled.div`
  display: inline-block;
  margin-left: 8px;
`;
